export default "__VITE_ASSET__C8o03hMO__"